import { loadTemplates } from '../common/api';

const templates = {
    name: 'templates',
    state: {
        loaded: false, 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.tid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.tid]: {
                        ...state.byId[payload.tid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.tid]: {
                        ...state.byId[payload.tid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.tid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedTemplates: ( state, payload ) => {
            return {
                ...state,
                loaded: true,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadTemplates( { aid, uid } ) {
            const list = await loadTemplates( aid, uid );
            let byId = {};
            list.forEach( c => byId[c.tid] = c );
            dispatch.templates.loadedTemplates( byId );
        },
        insert( { tid, cdc } ) {
            dispatch.templates.cdcInsert( { tid, cdc } );
        },
        modify( { tid, cdc } ) {
            dispatch.templates.cdcModify( { tid, cdc } );
        },
        remove( { tid } ) {
            dispatch.templates.cdcRemove( { tid } );
        },
        setCurrent( { tid } ) {
            dispatch.templates.setCurrentId( { tid } );
        }
    } )
}

export default templates;